import * as React from "react";
import { getTheme } from "@warda/library-ui/theme";
import { createUseStyles } from "react-jss";
import Toolbar from "@warda/library-ui/core/Toolbar";
import Divider from "@warda/library-ui/core/Divider";
import Placeholder from "@warda/library-ui/core/Placeholder";
import inLoading from "@warda/library-ui/utils/inLoading";
import Drawer from "../Drawer";
import { ERROR_GENERIC, PANEL_DETAIL_WIDTH_CLOSE } from "../../constants/keys";
import PlaceholderBtn from "./PlaceholderBtn";
const useStyles = createUseStyles({
    toolbar: {
        padding: "0 15px",
        alignSelf: "stretch",
    },
    divider: {
        alignSelf: "stretch",
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        backgroundColor: getTheme().colors.background,
    },
    detail: {
        width: PANEL_DETAIL_WIDTH_CLOSE,
        borderLeft: `1px solid ${getTheme().colors.grayBorder}`,
        backgroundColor: getTheme().colors.background,
    },
});
const PlaceholderViewport = ({ init }) => {
    const classes = useStyles({});
    const loading = inLoading(init) || !init;
    return (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { open: true, border: "right" },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(PlaceholderBtn, { loading: loading }),
                React.createElement("div", { style: { flex: 1 } })),
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(PlaceholderBtn, { loading: loading }),
                React.createElement("div", { style: { flex: 1 } }))),
        React.createElement("div", { className: classes.content },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement(PlaceholderBtn, { loading: loading }),
                React.createElement(PlaceholderBtn, { loading: loading }),
                React.createElement(PlaceholderBtn, { loading: loading }),
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(PlaceholderBtn, { loading: loading })),
            React.createElement(Divider, { className: classes.divider }),
            React.createElement("div", { style: { flex: 1, position: "relative" } },
                React.createElement(Placeholder, { spinner: loading, icon: "help", label: ERROR_GENERIC }))),
        React.createElement("div", { className: classes.detail })));
};
export default PlaceholderViewport;
